module.exports = __webpack_public_path__ + "img/osteopathie_und_physiotherapie.84d978c4.jpg";